import { useMediaQuery } from 'react-responsive'

export const useIsMobile = () => useMediaQuery({ maxWidth: 700 })

export const useIsTablet = () => useMediaQuery({ maxWidth: 963 })

export const useIsLaptop = () => useMediaQuery({ maxWidth: 1100 })

export const useIsLargeLaptop = () => useMediaQuery({ maxWidth: 1263 })
